import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import TradeTitle from '@/materials/atoms/TradeTitle.vue';
import HistoryList from '@/components/organisms/main/trade/history/HistoryList.vue';
import { historySubscriber } from '@/logics/history';
import { onMounted, onUnmounted } from 'vue';
import { useMessage } from '@/const/messages';
import { useHistory } from '@/logics/history';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean }
    },
    setup(__props) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const store = useStore();
            const histories = (([__temp, __restore] = _withAsyncContext(() => useHistory().getHistory())),
                __temp = yield __temp,
                __restore(),
                __temp);
            const { format, HISTORY_FIELDS } = useMessage();
            const { subscribe, unsubscribe, list } = historySubscriber(histories);
            onMounted(() => {
                subscribe();
                if (!props.isAuth) {
                    setTimeout(unsubscribe, process.env.VUE_APP_UNSUBSCRIBE * 1000);
                }
            });
            onUnmounted(unsubscribe);
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (!_unref(store).state.isSmartPhone)
                        ? (_openBlock(), _createBlock(TradeTitle, {
                            key: 0,
                            title: String(_unref(format)(_unref(HISTORY_FIELDS).TITLE))
                        }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                    _createVNode(HistoryList, {
                        histories: _unref(list),
                        class: "history"
                    }, null, 8, ["histories"])
                ], 64));
            };
        });
    }
});
